window.getLabelForInput = function (id) {
    var element = document.querySelector("label[for='" + id + "']");
    return element;
}
window.getSelectedRadio = function (name) {
    var options = document.getElementsByName(name);
    if (options) {
        for (var i = 0; i < options.length; i++) {
            if (options[i].checked) {
                return options[i].value;
            }
        }
    }
}

window.qs = function (selector) {
    /**
     * Just a shorthand method for document.querySelector
     */
    return document.querySelector(selector);
}

window.qsa = function (selector) {
    /**
     * Just a shorthand method for document.querySelectorAll
     */
    return document.querySelectorAll(selector);
}

/**
 * Control some other element when option selected.  Useful to show/hide related elements
 * when something selected.  Ex. a select with options yes/no, if yes selected, show input for
 * username.
 *
 * Selecting any other option reverses the change i.e. hides
 * Usage:
 * <select onchange="selectControls(this, "Yes", "show", ".myother-field");">...
 *
 * @param el
 * @param trigger_option (str)
 *  the selected option innerHTML
 * @param behavior (str)
 *  What to do if the option is selected, only "show" available currently.
 * @param selector
 *  The target to apply the behavior to
 */
window.selectControls = function (el, trigger_option, behavior, selector) {
    let selected_option = el.options[el.selectedIndex].innerHTML;
    if (behavior === "require") {
        if (selected_option === trigger_option) {
            qsa(selector).forEach(e => e.setAttribute("required", ""));
        } else {
            qsa(selector).forEach(e => e.removeAttribute("required"));
        }
    }
    if (behavior === "show") {
        if (selected_option === trigger_option) {
            qsa(selector).forEach(e => removeClass(e, 'is-hidden'));
        } else {
            qsa(selector).forEach(e => addClass(e, 'is-hidden'));
        }
    }

}

window.getCheckboxValues = function (selector) {
    /**
     * This will return a comma separated list of labels for selected multi-checkboxes.
     * If it only finds one checkbox matching the selector, it returns Yes/No if it's clicked.
     * @type {NodeListOf<*>}
     */
    let els = qsa(selector);
    if (els.length > 1) { // is multi-choice checkboxes
        let items = [];
        for (let i = 0; i < els.length; i++) {
            if (els[i].checked && !els[i].hasAttribute("disabled")) {
                items.push(getLabelForInput(els[i].id));
            }
        }
        return items.join(", ");
    } else {
        if (qs(selector).checked) {
            return "Yes"
        } else {
            return "No"
        }
    }
}

window.getSelectedOptionText = function (id) {
    var el = document.getElementById(id);
    if (el) {
        return el.options[el.selectedIndex].innerHTML;
    }
}

window.getSelectedOptionValue = function (id) {
    var el = document.getElementById(id);
    if (el) {
        return el.options[el.selectedIndex].value;
    }
}

window.addOption = function (select, text, value) {
    var option = document.createElement("option");
    option.text = text;
    option.value = value;
    select.appendChild(option);
}

window.removeOptionByValue = function (select, value) {
    select.removeChild(getOptionByValue(select, value));
}

window.getOptionByValue = function (select, value) {
    var options = select.options;
    for (var i = 0; i < options.length; i++) {
        if (options[i].value === value) {
            return options[i]
        }
    }
    return null
}

window.hasId = function (el, id) {
    return !!el.id.match(new RegExp('(\\s|^)' + id + '(\\s|$)'))
}

window.hasClass = function (el, className) {
    if (el.classList)
        return el.classList.contains(className)
    else
        return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
}

window.addClass = function (el, className) {
    if (el.classList)
        el.classList.add(className)
    else if (!hasClass(el, className)) el.className += " " + className
}

window.removeClass = function (el, className) {
    if (el.classList)
        el.classList.remove(className)
    else if (hasClass(el, className)) {
        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
        el.className = el.className.replace(reg, ' ')
    }
}
